import {
  allNewFieldsDraftFrame,
  allUpdatedFieldsDraftFrame,
  draftFrame,
  draftFrameWithEmptyFields,
  draftFrameWithEmptyFieldsComparedToLive,
  draftFrameWithNullFieldsComparedToLive,
} from 'mocks/server/data/draftFrames';
import {
  baseEntity,
  baseEntityWithEmptyFields,
  liveBaseEntity,
} from 'mocks/server/data/generation/generateBaseEntity';
import { broadsignFrame, formatSize } from 'mocks/server/data/generation/generateDetails';
import { IDraftEntityResponse, IDraftFrame } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { LiveStatus } from 'utils/statuses';

export const defaultDraftFrameResponse = (frame: IDraftFrame) => ({
  draft: frame,
  previous: {
    ...liveBaseEntity(frame),
    broadsignFrames: frame.broadsignFrames ? frame.broadsignFrames : [],
  },
});

export const draftFrameHandler = {
  [draftFrame.spaceId]: (frame: IDraftFrame): IDraftEntityResponse => {
    return defaultDraftFrameResponse(frame);
  },

  [draftFrameWithEmptyFields.spaceId]: (frame: IDraftFrame): IDraftEntityResponse => ({
    draft: frame,
    previous: { ...liveBaseEntity(frame), broadsignFrames: [] },
  }),

  [allNewFieldsDraftFrame.spaceId]: (frame: IDraftFrame): IDraftEntityResponse => ({
    draft: frame,
    previous: {
      ...baseEntityWithEmptyFields(frame.spaceId, EntityType.FRAME),
      broadsignFrames: [],
      status: LiveStatus.INACTIVE,
      hasDraft: false,
    },
  }),

  [allUpdatedFieldsDraftFrame.spaceId]: (frame: IDraftFrame): IDraftEntityResponse => {
    const liveFrame = baseEntity(EntityType.FRAME);
    return {
      draft: frame,
      previous: {
        ...liveFrame,
        spaceId: allUpdatedFieldsDraftFrame.spaceId,
        mediaOwnerName: 'oldMediaOwnerName',
        environment: 'oldEnvironment',
        formatSize: formatSize(),
        internetAccessAvailable: !frame.internetAccessAvailable,
        status: LiveStatus.ACTIVE,
        broadsignFrames: [broadsignFrame(), broadsignFrame(), broadsignFrame()],
        consolidatedResolutions: ['640x360', '1280x720', '1920x1080'],
        hasDraft: false,
      },
    };
  },

  [draftFrameWithNullFieldsComparedToLive.spaceId]: (frame: IDraftFrame): IDraftEntityResponse => ({
    draft: frame,
    previous: {
      ...baseEntity(EntityType.FRAME),
      spaceId: draftFrameWithNullFieldsComparedToLive.spaceId,
      broadsignFrames: [broadsignFrame(), broadsignFrame()],
      status: LiveStatus.ACTIVE,
      hasDraft: false,
    },
  }),

  [draftFrameWithEmptyFieldsComparedToLive.spaceId]: (
    frame: IDraftFrame
  ): IDraftEntityResponse => ({
    draft: frame,
    previous: {
      ...baseEntity(EntityType.FRAME),
      spaceId: draftFrameWithEmptyFieldsComparedToLive.spaceId,
      broadsignFrames: [broadsignFrame(), broadsignFrame()],
      status: LiveStatus.ACTIVE,
      hasDraft: false,
    },
  }),
};
